import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import {doc, onSnapshot, getDoc, updateDoc, arrayUnion, serverTimestamp, collection, query, where, orderBy, setDoc} from 'firebase/firestore';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import DebateFeed from './../DebateFeed/DebateFeed';
import AudioRecorder from './../AudioRecorder/AudioRecorder';
import { uploadAudioBlob } from '../../../utils/AudioUploader/AudioUploader';
import styles from './ArenaView.module.css';
import { useAuth } from "../../../utils/AuthContext/authcontext";
import { useParams } from "react-router";
import ContactSidebar from './../../ContactSidebar/ContactSidebar';
import CompactNavbar from './../../CompactNavbar/CompactNavbar';
import ArenaLoadingOverlay from './../ArenaLoadingOverlay/ArenaLoadingOverlay';
import { motion } from 'framer-motion';
import ArenaBanner from './../ArenaBanner/ArenaBanner';
import DebaterColumn from './../DebaterColumn/DebaterColumn';
import Button from '../../ui/Button';
import ModeratorBox from './../ModeratorBox/ModeratorBox';
import SpectatorBench from './../SpectatorBench/SpectatorBench';
import ArenaListView from './../ArenaListView/ArenaListView';
import AudioSequencePlayer from "../../../utils/AudioSequencePlayer/AudioSequencePlayer";

import TurnTimeline from './../TurnTimeline/TurnTimeline';
import { debateTypes } from '../debateFormatsDataV3';
import { useDebateRoom } from '../../../utils/useDebateRoom/useDebateRoom';


function CountdownCircle({timer, total}) {
  const radius = 30, circumference = 2 * Math.PI * radius;
  const offset = ((total - timer) / total) * circumference;
  return (
    <svg width="70" height="70">
      <circle cx="35" cy="35" r={radius} stroke="#fca311" strokeWidth="6" fill="transparent"
              strokeDasharray={circumference} strokeDashoffset={offset} />
      <text x="35" y="40" textAnchor="middle" fontSize="18" fill="white">{timer}s</text>
    </svg>
  );
}


const ArenaView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user: currentUser, userData: currentUserData, logout, login, claims } = useAuth();
  const [replyToRecord, setreplyToRecord] = useState(null);
  const [arena, setArena] = useState(null);
  const [arenaMeta, setArenaMeta] = useState(null);
  const [messages, setMessages] = useState([]);
  const [groupMessages, setGroupMessages] = useState(null);
  const [arenaId, setArenaId] = useState(null);
  const [participantRole, setParticipantRole] = useState('spectator');
  const [timer, setTimer] = useState(0);
  const [isContactOpen, setContactOpen] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);
  const [focusThreadId, setFocusThreadId] = useState(null);
  const [currentScores, setCurrentScores] = useState({});
  const timerRef = useRef(null);
  const recorderRef = useRef();
  const hasRunRef = useRef(false);
	const hasResetRef = useRef(false);
  let params = useParams();
  const meta = debateTypes.find(m => m.id === arena?.formatId?.toLowerCase()) || {};

  const hasModeratorRole = () => {
    return arena?.roles?.moderator?.uid === currentUser?.uid;
  };

  const hasSpectatorRole = () => {
    return arena?.spectators?.some(s => s.uid === currentUser?.uid);
  };

  const hasParticipantRole = () => {
    return arena?.roles?.debaters?.some(d => d?.uid === currentUser?.uid);
  };

  const hasNoRole = () => {
    return !hasModeratorRole() && !hasSpectatorRole() && !hasParticipantRole();
  };

  const roleAsString = () => {
    if(hasModeratorRole()) return meta.role || "moderator";
    if(hasSpectatorRole()) return "spectator";
    if(hasParticipantRole()) return "debater";
    return "none";
  }

  const {
  state,
  activeTurn,
  currentRound,
  roundActive,
  lastEvent,
  activeSpeakers,
  actions,
  speakerHelpers,
  spectatorActions,
  engineEvents,
  capabilities,
  } = useDebateRoom({ debateId: arenaId, userId: currentUser?.uid, userRole: roleAsString(), debateTypeId: meta.id, tickInterval: 0, tickValue:1 });
  
     
  //console.log(roleAsString(), meta, meta.id, currentUser.uid, arenaId, arena, hasModeratorRole(), hasSpectatorRole(), hasParticipantRole(), hasNoRole());

  //console.log(state, activeTurn, lastEvent, activeSpeakers, actions, speakerHelpers, spectatorActions, engineEvents, capabilities);
  
  //console.log(state, activeTurn, lastEvent, activeSpeakers, currentRound, roundActive, engineEvents, capabilities);
  

  //console.log(state, activeTurn, lastEvent, engineEvents);

  useEffect(() => {
  if (!actions || hasResetRef.current != false || actions.isengineReady == false) return;

  if(state.status !== 'idle') {
    //actions.resetDebate();
  }
  else
  {
    hasResetRef.current = true;
  }
}, [actions]); // re-run when state or activeTurn updates

  useEffect(() => {
    if(arena == undefined || arenaId == undefined || meta == undefined || currentUser == undefined || arenaMeta == undefined || arenaMeta.id !== arena.formatId?.toLowerCase()) return;
    var isModeratorValid = arenaMeta?.roles?.judge?.exists === true || arenaMeta?.roles?.moderator?.exists === true || false;
    var isModerator = false;
    if(isModeratorValid) {
      isModerator = arena?.roles?.moderator?.uid === currentUser?.uid;
    }
    const isDebater = arena?.roles?.debaters?.some(d => d?.uid === currentUser.uid);
    const isSpectator = arena?.spectators?.find(s => s.uid === currentUser.uid) || false;
    const NoSpectators = arena?.spectators?.length || 0;
    //console.log('OLD arena meta:', arenaMeta);
    //console.log(isModeratorValid, isModerator, meta.id,arena.formatId, arenaMeta?.roles?.judge?.exists, arenaMeta?.roles?.moderator?.exists);
    //console.log('Checking arena access:', { arenaId, isModerator, isDebater, isSpectator, NoSpectators, canParticipate: meta?.spectators?.canParticipate });  

    if(arena != undefined && (!isDebater && !isModerator && !isSpectator) && (NoSpectators > 100 || !meta?.spectators?.canParticipate )){
      async function navigateToHome() {
        await navigate('/home');
      }
      navigateToHome();

    }
  }, [arena, arenaMeta, meta]);


  useEffect(() => {
	if(arenaId == undefined) return;
    const q = query(collection(firestore, 'arenas', arenaId, 'messages'), orderBy('timestamp', 'asc')
    );
    const unsub = onSnapshot(q, snapshot => {
      const msgs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	  setMessages(msgs);
    });
    return () => unsub();
  }, [arenaId]);


  useEffect(() => {
	if(arena != undefined && messages != undefined && messages.length > 0){
	  
	  
	  var isModerator = arena.roles.moderator?.uid === currentUser?.uid;
	  const filteredmessages = isModerator == true ? messages : messages?.filter(d => d?.acceptable === 1);
	  //const all = [...messages];
	   const all = [...filteredmessages];
	  
	  const groupedByThread = all.reduce((acc, m) => {
		const threadId = m.threadid || 'main';
		acc[threadId] = acc[threadId] || [];
		acc[threadId].push(m);
		return acc;
	  }, {});

	  const groupedByTeam = all.reduce((acc, m) => {

		const gov = arena?.roles?.debaters.filter(d => d?.team === arena.custom.teams[0] && d?.uid === m.senderId) || '';
		const opp = arena?.roles?.debaters.filter(d => d?.team === arena.custom.teams[1] && d?.uid === m.senderId) || '';

		const teamgov = gov.length > 0 ? arena.custom.teams[0] : null;
		const teamopp = opp.length > 0 ? arena.custom.teams[1] : null;
		
		const team = teamgov || teamopp || 'Unknown';
		acc[team] = acc[team] || [];
		acc[team].push(m);
		return acc;
	  }, {});

	  setGroupMessages({all, groupedByThread, groupedByTeam});
	}
	else {
		setGroupMessages(null);
	}
	
  }, [arena, messages, location.key]);


  useEffect(() => {
	if(params.id){
		setShowOverlay(true);
	  setArenaId(params.id);
	} else {
		//navigate('/home');
		setArena(null);
		setArenaId(null);
    setCurrentScores({}); // reset scores when arena changes
	}
	
  }, [params.id]);

  useEffect(() => {
    if(arena){
    const meta = debateTypes.find(m => m.id === arena.formatId?.toLowerCase()) || {};
    setArenaMeta(meta); 
    setTimeout(() => {
          setShowOverlay(false);
        }, 1000);
        
    }
  }, [arena]);

  const aggregateScores = (messages) => {
  const scoreMap = {};

  messages.forEach((msg) => {
    const { senderId, score = 0 } = msg;

    if (!senderId) return;

    scoreMap[senderId] = (scoreMap[senderId] || 0) + score;
  });

  // convert to array
  return Object.entries(scoreMap).map(([senderId, totalScore]) => ({
    senderId,
    totalScore: Math.max(0, totalScore), // clamp once here
  }));
}

const buildScoreMap = (scores) =>   {
  return Object.fromEntries(
    scores.map(s => [s.senderId, s.totalScore])
  );
}

useEffect(() => {
  if(messages == undefined || messages.length == 0) return
  const scoresArray = aggregateScores(messages);
  setCurrentScores(buildScoreMap(scoresArray));
}, [messages]);
  
  // Subscribe to the arena and manage role + timer
  useEffect(() => {
	if(arenaId == undefined) return;
    
	const arenaRef = doc(firestore, 'arenas', arenaId);

    const unsub = onSnapshot(arenaRef, (snap) => {
      const data = snap.data();
	  if(data == undefined) return;
      setArena({ id: snap.id, ...data });
      const participant = data.participants?.find(p => p.uid === currentUser.uid);
      setParticipantRole(participant?.role || (currentUser.uid === data.moderator ? 'moderator' : 'spectator'));
      if (data.roundActive) {
        setTimer(data.turnTimeLimit || 30);
      } else {
        setTimer(0);
      }
    });
    return () => unsub();
  }, [arenaId, currentUser.uid]);

  const mlogout = () => {
  }

  useEffect(() => {
    if (arena?.roundActive && timer > 0) {
      timerRef.current = setTimeout(() => {
        setTimer(timer - 1);
      }, 1000);
    } else if (arena?.roundActive && timer === 0 && recorderRef.current) {
      recorderRef.current.stopRecording();
    }
    return () => clearTimeout(timerRef.current);
  }, [timer, arena?.roundActive]);

  const startRound = async () => {
    await updateDoc(doc(firestore, 'arenas', arenaId), {
      currentRound: (arena.currentRound || 0) + 1,
      currentTurn: 0,
      roundActive: true,
    });
  };

  const nextTurn = async () => {
    const next = ((arena.currentTurn || 0) + 1) % arena.participants.length;
    await updateDoc(doc(firestore, 'arenas', arenaId), { currentTurn: next });
  };

  const endRound = async () => {
    await updateDoc(doc(firestore, 'arenas', arenaId), { roundActive: false });
  };

  const handleScore = async (uid, delta) => {
    const current = currentScores[uid] || 0;
    const updated = { ...currentScores, [uid]: current + delta };
    //console.log('Updating scores:', updated); 
    //setCurrentScores(updated);
  }

  const handleReply = (msgid, displayId, senderName) => {
	  setreplyToRecord({msgid, displayId, senderName});
  };
  
  const handleNextTurn = (obj) => {
    console.log(obj);
  };

  const handleSetThreadId = (threadid) => {
	setFocusThreadId(threadid)
  };
  
  var canSend = ['participant', 'moderator'].includes(participantRole);
  var isModerator = participantRole === 'moderator';
  var currentSpeaker = arena != undefined ? arena.participants?.[arena.currentTurn]?.uid : null;

  var gov = [];
  var opp = [];
  var currentUserGov = null;
  var currentUserOpp = null;
  if(arena?.roles?.debaters.length != undefined) {
    gov = arena?.roles?.debaters.filter(d => d?.team === arena.custom.teams[0]);
    currentUserGov = gov?.find(s => s.uid === currentUser.uid);
    opp = arena?.roles?.debaters.filter(d => d?.team === arena.custom.teams[1]);
    currentUserOpp = opp?.find(s => s.uid === currentUser.uid);
  }
  //currentUserData, currentUser, sendMessage, arenaId, arena, moderator, teams, debaters, handleStopRound, handleEndRound,handleAddScore, handleSwitchTurn, handleEndDebate
  //console.log(arena, canSend, isModerator, currentSpeaker);
  //console.log(currentUserGov?.team, currentUserOpp?.team);
  var currentUserteam = currentUserGov?.team || currentUserOpp?.team;
  var isModeratorValid = arenaMeta?.roles?.judge?.exists === true || arenaMeta?.roles?.moderator?.exists === true || false;
  var isModerator = false;
  if(isModeratorValid) {
	  isModerator = arena?.roles?.moderator?.uid === currentUser?.uid;
  }
  const isDebater = arena?.roles?.debaters?.some(d => d?.uid === currentUser.uid);
  const isSpectator = arena?.spectators?.find(s => s.uid === currentUser.uid) || false;
  const NoSpectators = arena?.spectators?.length || 0;
  const filteredmessages = messages?.filter(d => d?.acceptable === 1 || d?.acceptable === undefined);

  const canStartDebate = capabilities?.canStartDebate;

  const handleSaveAudio = async (blob, duration, triggerRecording ) => {
    if (!arenaId || !currentUser || state?.status !== 'active') return;

	  const messageId = doc(collection(firestore, 'arenas', arenaId, 'messages')).id;
    const url = await uploadAudioBlob({ arenaId, messageId, blob });

    if(triggerRecording != null) {
      await updateDoc(doc(firestore,'arenas', arenaId, 'messages', triggerRecording.msgid), {
        threadid: triggerRecording != null ? triggerRecording.displayId : null,
      });
    }

    actions.addMessage(currentUser.uid, {speakerId: currentUser.uid, team: currentUserteam, durationSec: duration, audioUrl: url});
	  setreplyToRecord(null);
	  actions?.setCurrentSpeaker(null);

    await setDoc(doc(firestore,'arenas', arenaId, 'messages', messageId), {
      arenaId,
      senderId: currentUser.uid,
      type: 'audio',
      audioUrl: url,
	    replyto: triggerRecording != null ? triggerRecording.senderName : null,
	    threadid: triggerRecording != null ? triggerRecording.displayId : null,
      duration: duration, //Math.floor(blob.size / 10000),
      timestamp: serverTimestamp(),
      round: state.currentRound || 1,
      turn: state.turnIndex + 1 || 1,
      score: 0,
	  acceptable: 1,
    });
  };

  const onRecordingStarted = () => {
    if (!actions?.setCurrentSpeaker) return;
    actions?.setCurrentSpeaker(currentUser?.uid);
    //console.log("role:", currentUserteam, currentUser?.uid); 
  };

  const handleStartDebate = async () => {
    if (!actions?.startDebate) return;
    if (capabilities.canStartDebate && state.status === 'idle' && hasRunRef?.current === false) {
			hasRunRef.current = true;
			await actions.startDebate();
    }
  };

  const handleEndTurn = async () => {
    if (!actions?.startDebate) return;
    if (capabilities.canEndTurn && state.status === 'active') {
      await actions.endTurn();
    }
  };

  return (
    <>
      <div className={styles.headernav}>
        <CompactNavbar shownow={false} modal={true} scrollY={0} openContact={() => setContactOpen(true)}  openLogin={(user) => {user != null ? logout(true) : mlogout()}}/>
      </div>
      <div className={styles.container}>
        {arena != undefined ? <>{arena != null ? <div className={styles.arena}>
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity:1, y:0 }} transition={{ duration:0.5 }}>
        <ArenaBanner scores={currentScores} currentUser={currentUser} state={state} activeTurn={activeTurn} arena={arena} canStartDebate={canStartDebate} debateStatus={state?.status} onStartDebate={handleStartDebate} />
      </motion.div>
        <><TurnTimeline state={state} activeTurn={activeTurn} arena={arena} formatId={arena.formatId}  isModerator={isModerator} handleNextTurn={handleNextTurn}/></>
          <div className={styles.battleZone}>
            <DebaterColumn  arenaMeta={arenaMeta} isSingleTeam={arena?.custom?.teams?.length < 2 } isModerator={isModerator} moderatorPresent={isModeratorValid} position="left" onFilterMessage={(threadId) => handleSetThreadId(threadId)} gfocusThreadId={focusThreadId} messages={isModerator == true ? messages : filteredmessages} OnhandleReply={handleReply} replyToRecord={replyToRecord} arenaId={arenaId} onAudioSave={handleSaveAudio} onRecordingStarted={onRecordingStarted} iscurrentUserInTeam={currentUserGov != undefined ? true: false} user={currentUser} team={gov} state={state} activeTurn={activeTurn} arena={arena} formatId={arena.formatId} actions={actions} capabilities={capabilities}/>
            {isModeratorValid ? <ModeratorBox capabilities={capabilities} handleEndTurn={handleEndTurn} handleAddScore={handleScore} role={arenaMeta?.role} isSingleTeam={arena?.custom?.teams?.length < 2 } currentUserteam={currentUserteam} moderator={arena?.roles?.moderator} debaters={arena?.roles?.debaters} teams={arena.custom.teams} arena={arena} arenaId={arenaId} currentUser={currentUser} currentUserData={currentUserData} />: <></>}
            {arena?.custom?.teams?.length >= 2 ? <DebaterColumn  arenaMeta={arenaMeta} isSingleTeam={arena?.custom?.teams?.length < 2 } isModerator={isModerator}  moderatorPresent={isModeratorValid} position="right" onFilterMessage={(threadId) => handleSetThreadId(threadId)} gfocusThreadId={focusThreadId} messages={isModerator == true ? messages : filteredmessages} OnhandleReply={handleReply} replyToRecord={replyToRecord} arenaId={arenaId} onAudioSave={handleSaveAudio} onRecordingStarted={onRecordingStarted} iscurrentUserInTeam={currentUserOpp != undefined ? true: false} user={currentUser} team={opp} state={state} activeTurn={activeTurn} arena={arena} formatId={arena.formatId}  actions={actions} capabilities={capabilities}/> : <></>}
          </div>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}>
      
        {groupMessages != null && (<>
          <AudioSequencePlayer  messages={groupMessages?.all} groupedByThread={groupMessages?.groupedByThread} groupedByTeam={groupMessages?.groupedByTeam}/>
        </>)}
      
        {arenaMeta?.spectators?.canParticipate == true ? <SpectatorBench arenaMeta={arenaMeta} arenaId={arenaId} spectators={arena.spectators || []} />: <></>}
      </motion.div>
        </div>: <></>}</> : <ArenaListView  currentUser={currentUserData} OnComplete={() => {setShowOverlay(false)}}/>}
      </div>
      <ContactSidebar isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
      {showOverlay && <ArenaLoadingOverlay msg={"Loading your arena..."} onComplete={() => {}} />}
	</>
  );
};

export default ArenaView;


export  function ArenaVieww() {
  const { user: currentUser, userData, logout, login, claims } = useAuth();
  const [arena, setArena] = useState(null);
  const [arenaId, setArenaId] = useState(null);
  const [participantRole, setParticipantRole] = useState('spectator');
  const [timer, setTimer] = useState(0);
  const [isContactOpen, setContactOpen] = useState(false);
   const [showOverlay, setShowOverlay] = useState(true);
 
  const timerRef = useRef(null);
  const recorderRef = useRef();
  let params = useParams();
  
  useEffect(() => {
	setShowOverlay(true);
	if(params.id){
	    setArenaId(params.id);
	}
  }, [params.id]);

  useEffect(() => {
	if(arena){
	setTimeout(() => {
        setShowOverlay(false);
      }, 1000);
	    
	}
  }, [arena]);

  // Subscribe to the arena and manage role + timer
  useEffect(() => {
    if(arenaId == undefined) return;
    
	const arenaRef = doc(firestore, 'arenas', arenaId);

    const unsub = onSnapshot(arenaRef, (snap) => {
      const data = snap.data();
      setArena({ id: snap.id, ...data });
      const participant = data.participants?.find(p => p.uid === currentUser.uid);
      setParticipantRole(participant?.role || (currentUser.uid === data.moderator ? 'moderator' : 'spectator'));
      if (data.roundActive) {
        setTimer(data.turnTimeLimit || 30);
      } else {
        setTimer(0);
      }
    });
    return () => unsub();
  }, [arenaId, currentUser.uid]);

  
  const mlogout = () => {
  }

  useEffect(() => {
    if (arena?.roundActive && timer > 0) {
      timerRef.current = setTimeout(() => {
        setTimer(timer - 1);
      }, 1000);
    } else if (arena?.roundActive && timer === 0 && recorderRef.current) {
      recorderRef.current.stopRecording();
    }
    return () => clearTimeout(timerRef.current);
  }, [timer, arena?.roundActive]);

  const startRound = async () => {
    await updateDoc(doc(firestore, 'arenas', arenaId), {
      currentRound: (arena.currentRound || 0) + 1,
      currentTurn: 0,
      roundActive: true,
    });
  };

  const nextTurn = async () => {
    const next = ((arena.currentTurn || 0) + 1) % arena.participants.length;
    await updateDoc(doc(firestore, 'arenas', arenaId), { currentTurn: next });
  };

  const endRound = async () => {
    await updateDoc(doc(firestore, 'arenas', arenaId), { roundActive: false });
  };

  const handleSaveAudio = async (blob) => {
	const messageId = doc(collection(firestore, 'messages')).id;
    const url = await uploadAudioBlob({ arenaId, messageId, blob });

    await setDoc(doc(firestore, 'messages', messageId), {
      arenaId,
      senderId: currentUser.uid,
      type: 'audio',
      audioUrl: url,
      duration: Math.floor(blob.size / 10000),
      timestamp: serverTimestamp(),
      round: arena.currentRound,
      turn: arena.currentTurn,
      score: 0,
    });
  };

  //console.log(arena);

  var canSend = ['participant', 'moderator'].includes(participantRole);
  var isModerator = participantRole === 'moderator';
  var currentSpeaker = arena != undefined ? arena.participants?.[arena.currentTurn]?.uid : null;

  return (
    <>
	<div className={styles.headernav}>
		<CompactNavbar shownow={false} modal={true} scrollY={0} openContact={() => setContactOpen(true)}  openLogin={(user) => {user != null ? logout(true) : mlogout()}}/>
	</div>
    {arena != undefined ? <div className={styles.container}>
      <header className={styles.header}>
        <h2>{arena.title}</h2>
        <div className={styles.meta}>
          <span>Format: {arena.formatId}</span>
          {arena.currentRound && <span>Round {arena.currentRound}</span>}
          {arena.roundActive && (
            <>
              <span>Speaker: {currentSpeaker === currentUser.uid ? 'You' : currentSpeaker}</span>
              <CountdownCircle timer={timer} total={arena.turnTimeLimit || 30} />
            </>
          )}
        </div>
      </header>

      <div className={styles.main}>
        <div className={styles.feed}>
          <DebateFeed arenaId={arenaId} currentUser={currentUser} isModerator={isModerator} />
        </div>

        <div className={styles.sidePanel}>
          {canSend && arena.roundActive && (
            <AudioRecorder ref={recorderRef} onSave={handleSaveAudio} />
          )}

          {isModerator && (
            <div className={styles.modControls}>
              {!arena.roundActive ? (
                <Button variant="secondary" onClick={startRound}>Start Round</Button>
              ) : (
                <>
                  <Button variant="secondary" onClick={nextTurn}>Next Turn</Button>
                  <Button variant="secondary" onClick={endRound}>End Round</Button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div> :  <div>Loading arena?...</div>}
	<ContactSidebar isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
	{showOverlay && <ArenaLoadingOverlay msg={"Loading your arena..."} onComplete={() => {}} />}
	</>
  );
}
